/*
 * La Mimoteca Peluda - Traduccion al espanol de los avisos de seguimiento de Track123.
 *
 * Track123 (plan gratuito) muestra los avisos del transportista en ingles. Este script
 * los traduce en el navegador del cliente con una tabla propia. No modifica nada en Track123.
 *
 * Como funciona:
 *  - Cada aviso suele venir como "[Ciudad CP] Texto principal, Carrier note: Nota del transportista".
 *  - La parte entre corchetes (ciudad y codigo postal del cliente) se deja tal cual.
 *  - El texto principal y la nota se traducen por separado con las tablas MAIN y NOTE.
 *  - Lo que no esta en las tablas se deja en ingles (no se rompe nada).
 *
 * Para anadir una frase nueva: copiala en minusculas, sin punto final y con apostrofo simple,
 * en la tabla MAIN (texto principal) o NOTE (nota del transportista), con su traduccion.
 */
(function () {
  'use strict';

  var isBrowser = typeof document !== 'undefined';

  if (isBrowser) {
    // Solo en tiendas en espanol y solo en paginas de seguimiento o de pedidos.
    if (!/^es/i.test(document.documentElement.lang || '')) return;
    if (!/(apps\/|seguimiento|track|orders\/)/i.test(location.pathname)) return;
  }

  // ---- Texto principal del aviso -------------------------------------------------------
  var MAIN = {
    // Almacen y origen (China)
    'shipment information received by warehouse electronically': 'Información del envío recibida electrónicamente por el almacén',
    'package ready for shipping from warehouse': 'Paquete listo para su envío desde el almacén',
    'package shipped out from warehouse': 'Paquete enviado desde el almacén',
    'processing at sorting center': 'En proceso en el centro de clasificación',
    'departed from sorting center': 'Salida del centro de clasificación',
    'carrier update': 'Actualización del transportista',
    'arrived at departure transport hub': 'Llegada al centro de transporte de origen',
    'export customs clearance started': 'Inicio del despacho de aduana de exportación',
    'export customs clearance complete': 'Despacho de aduana de exportación completado',
    'leaving from departure country/region': 'Saliendo del país o región de origen',
    'departed from departure country/region': 'Salida del país o región de origen',
    'arrived at linehaul office': 'Llegada a la oficina de transporte de larga distancia',

    // Importacion y destino (Espana)
    'import customs clearance started': 'Inicio del despacho de aduana de importación',
    'import customs clearance complete': 'Despacho de aduana de importación completado',
    'departed from customs': 'Salida de aduana',
    'arrived at destination country/region sorting center': 'Llegada al centro de clasificación del país de destino',
    'departed from destination country/region sorting center': 'Salida del centro de clasificación del país de destino',
    'received by local delivery company': 'Recibido por la empresa de reparto local',
    'out for delivery': 'En reparto',
    'arrived at pick-up point. package available for collection': 'Llegada al punto de recogida. Paquete disponible para su recogida',
    'package delivered': 'Paquete entregado',

    // Frases habituales de otros transportistas (aun no vistas en nuestros pedidos)
    'info received': 'Información del envío recibida',
    'in transit': 'En tránsito',
    'delivered': 'Entregado',
    'available for pickup': 'Disponible para recoger',
    'package available for collection': 'Paquete disponible para su recogida',
    'arrived at pick-up point': 'Llegada al punto de recogida',
    'arrived at destination country/region': 'Llegada al país de destino',
    'arrived at delivery facility': 'Llegada a la oficina de reparto',
    'shipment picked up': 'Envío recogido',
    'delivery attempted': 'Intento de entrega fallido',
    'failed delivery attempt': 'Intento de entrega fallido',
    'delivery failed': 'Intento de entrega fallido',
    'delivery exception': 'Incidencia en la entrega',
    'exception': 'Incidencia en el envío',
    'returned to sender': 'Devuelto al remitente',
    'package returned to sender': 'Paquete devuelto al remitente'
  };

  // ---- Nota del transportista ("Carrier note") -----------------------------------------
  var NOTE = {
    'order received successfully': 'pedido recibido correctamente',
    'package finished': 'paquete preparado',
    'leave the warehouse': 'sale del almacén',
    'inbound in sorting center': 'entrada en el centro de clasificación',
    'outbound in sorting center': 'salida del centro de clasificación',
    'last-mile delivery forecast': 'previsión de entrega del último tramo',
    'arrived at departure transport hub': 'llegada al centro de transporte de origen',
    'export customs clearance started': 'inicio del despacho de aduana de exportación',
    'export clearance success': 'despacho de exportación correcto',
    'left from departure country/region': 'salida del país o región de origen',
    'leaving from departure country/region': 'saliendo del país o región de origen',
    'arrived at linehual office': 'llegada a la oficina de transporte de larga distancia',
    'arrived at linehaul office': 'llegada a la oficina de transporte de larga distancia',
    'import clearance start': 'inicio del despacho de importación',
    'import customs clearance complete': 'despacho de aduana de importación completado',
    'leaving customs': 'salida de aduana',
    'your shipment has arrived at sorting center': 'tu envío ha llegado al centro de clasificación',
    'your shipment has been processed at sorting center and ready for shipping': 'tu envío ha sido procesado en el centro de clasificación y está listo para su envío',
    'your shipment has been accepted by delivery carrier': 'tu envío ha sido aceptado por el transportista',
    'your shipment is out for delivery': 'tu envío está en reparto',
    "your shipment has arrived at parcelshop and you'll receive pickup instructions shortly": 'tu envío ha llegado al punto de recogida y recibirás las instrucciones de recogida en breve',
    'your shipment has been collected by consignee at the parcelshop': 'el destinatario ha recogido tu envío en el punto de recogida',
    'your shipment has been delivered successfully': 'tu envío se ha entregado correctamente'
  };

  // Normaliza para comparar: apostrofos, espacios, punto final y mayusculas.
  function norm(s) {
    return String(s)
      .replace(/[‘’´`]/g, "'")
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/[.\s]+$/, '')
      .toLowerCase();
  }

  // Devuelve el texto traducido o null si no se reconoce nada.
  function translateLine(text) {
    var m = text.match(/^(\s*\[[^\]]*\]\s*)?([\s\S]*)$/);
    var prefix = (m && m[1]) || '';
    var rest = (m && m[2]) || '';
    var parts = rest.split(/,\s*Carrier note:\s*/i);
    var main = parts[0];
    var note = parts.length > 1 ? parts.slice(1).join(', ') : '';

    var mainKey = norm(main);
    var noteKey = note ? norm(note) : '';
    var mainEs = Object.prototype.hasOwnProperty.call(MAIN, mainKey) ? MAIN[mainKey] : null;
    var noteEs = noteKey && Object.prototype.hasOwnProperty.call(NOTE, noteKey) ? NOTE[noteKey] : null;

    if (!mainEs && !noteEs) return null;

    var out = prefix + (mainEs || main.trim());
    // Si la nota repite el texto principal, no se muestra dos veces.
    if (note && noteKey !== mainKey) {
      out += '. Nota del transportista: ' + (noteEs || note.trim());
    }
    return out;
  }

  if (!isBrowser) {
    // Para pruebas fuera del navegador.
    module.exports = { translateLine: translateLine };
    return;
  }

  function handle(node) {
    var t = node.nodeValue;
    if (!t || t.length < 6 || t.length > 800) return;
    var p = node.parentNode;
    if (p && /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT)$/.test(p.nodeName)) return;
    var out = translateLine(t);
    if (out && out !== t) node.nodeValue = out;
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { handle(root); return; }
    if (root.nodeType !== 1) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var list = [];
    var n;
    while ((n = w.nextNode())) list.push(n);
    for (var i = 0; i < list.length; i++) handle(list[i]);
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { walk(document.body); }, 150);
  }

  function start() {
    walk(document.body);
    // Track123 carga el historial despues de abrir la pagina: se vigilan los cambios.
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
